import { render, staticRenderFns } from "./BaseStatusHelp.vue?vue&type=template&id=6f7fa41e&scoped=true"
import script from "./BaseStatusHelp.vue?vue&type=script&lang=js"
export * from "./BaseStatusHelp.vue?vue&type=script&lang=js"
import style0 from "./BaseStatusHelp.vue?vue&type=style&index=0&id=6f7fa41e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f7fa41e",
  null
  
)

export default component.exports